/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OperationOriginEnum = 'OPERATOR' | 'SYSTEM';

export const OperationOriginEnum = {

    OPERATOR: 'OPERATOR' as OperationOriginEnum,

    SYSTEM: 'SYSTEM' as OperationOriginEnum
};

